import { CardStackV2 } from "../ui/widgets/cardStackV2.ts";
import {
  fetchRecommendationPostsWithAutoTags,
  fetchRecommendationPostsWithManualTags,
} from "../utils/searchService.ts";
import { createLogger } from "../utils/logger.ts";
import { WidgetWrapper } from "../utils/WidgetWrapper.ts";
import { WidgetRenderProps, Post } from "../types.ts";

export async function renderV8({
  pageConfig,
  experiment,
}: WidgetRenderProps): Promise<HTMLElement | null> {
  let posts: Post[] = [];

  posts = await fetchRecommendationPostsWithAutoTags(pageConfig, 5, "v1");

  // Fallback to manual tags if auto tags fail (e.g. if no auto tags are set for current article)
  if (posts.length === 0) {
    console.debug(
      "[MM Recirculation Widget] No auto-tags found so falling back to manual tags"
    );
    posts = await fetchRecommendationPostsWithManualTags(pageConfig, 5, "001");
  }

  if (posts.length === 0) {
    return null;
  }

  const logger = createLogger(experiment);

  let title = "More like this";

  if (
    ["www.si.com", "www.mentalfloss.com"].includes(window.location.hostname)
  ) {
    title = "More Like This";
  }

  return WidgetWrapper(
    logger,
    posts,
    CardStackV2({
      title,
      posts: posts,
      siteRenderer: pageConfig.siteRenderer,
      logger,
    })
  );
}
